import { render, staticRenderFns } from "./PromotionNew.vue?vue&type=template&id=32f49f6d&scoped=true"
import script from "./PromotionNew.vue?vue&type=script&lang=js"
export * from "./PromotionNew.vue?vue&type=script&lang=js"
import style0 from "./PromotionNew.vue?vue&type=style&index=0&id=32f49f6d&prod&lang=scss&scoped=true"
import style1 from "./PromotionNew.vue?vue&type=style&index=1&id=32f49f6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f49f6d",
  null
  
)

export default component.exports